import { createAction } from '@reduxjs/toolkit';
import { Map as ImmutableMap } from 'immutable';

import { rootUiActions, rootUiTypes } from '../../root-ui';
import type { AggAction } from '../accountDiscoveryTypes';

export const createErrorDialog = createAction(rootUiActions.createDialog.type, (error: AggAction, meta?: unknown) => ({
  payload: rootUiTypes.mkRootUiData({
    type: 'DIALOG_CONFIRMATION',
    allowNesting: false,
    props: ImmutableMap({
      title: error.title,
      content: `${error.text} ${error.statusCode ? `Care Code: ${error.statusCode}` : ''}`,
      confirmLabel: error.actionLabel,
      confirmAction: error.action,
      denyLabel: 'Cancel',
      unregisterContentViewOnClose: true,
    }),
  }),
  meta,
}));
